import React from 'react';

const AppliedFilters = ({
  appliedFilters,
  setAppliedFilters,
  updateCategoryWiseFilters,
  afterApplyFilter,
  setAfterApplyFilter,
  afterApplyFilterNeu,
  setAfterApplyFilterNeu,
  setApplySelectedFilters,
  applySelectedFilters,
  filtersAppliedone,
  setFiltersAppliedone,
  filtersAppliedoneTrue,
  setFiltersAppliedoneTrue,
}) => {
  const handleRemoveFilter = filterToRemove => {
    const newfilters = appliedFilters.filter(
      each =>
        each.name != filterToRemove.name || each.value != filterToRemove.value
    );
    // console.log(filterToRemove, newfilters, 'newfilters', appliedFilters);
    // updateCategoryWiseFilters(newfilters);

    // setFiltersAppliedone(newfilters);
    // setApplySelectedFilters(newfilters);
    // updateCategoryWiseFilters(newfilters);
    setAppliedFilters(newfilters);
    // setAfterApplyFilter(newfilters);
    // setAfterApplyFilterNeu(newfilters);
    // setFiltersAppliedoneTrue(true);
    // var x = document.getElementById('reapplyfilter');
    // x.click();
  };
  // console.log(afterApplyFilterNeu, 'afterApplyFilterNeu');
  return (
    <div className="applied-filter">
      <div>
        {appliedFilters &&
          appliedFilters.map(filter => {
            const uppercaseWords = str =>
              str.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());
            return (
              <label key={filter.value} className="applied-filter-label">
                <span>{filter.displayName}</span>
                <span onClick={() => handleRemoveFilter(filter)}>
                  {uppercaseWords(filter.value)}{' '}
                  <em
                    style={{ fontStyle: 'inherit' }}
                    className={'closefilter-fill'}
                  >
                    X
                  </em>{' '}
                </span>
              </label>
            );
          })}
      </div>
      <div className="applied-filters-clear">
        {appliedFilters && appliedFilters.length > 0 && (
          <a
            id="clear-filters"
            onClick={() => {
              setAppliedFilters([]);
              setAfterApplyFilter([]);
              setAfterApplyFilterNeu([]);
              setApplySelectedFilters([]);
              setFiltersAppliedone([]);
              updateCategoryWiseFilters([]);
              setFiltersAppliedoneTrue(true);
            }}
          >
            Clear Filters
          </a>
        )}
      </div>
    </div>
  );
};

export default AppliedFilters;
